import React from 'react';
import '../../styles/GeogusserFlowStatus.css';

/**
 * Centered GeoGuessr loading copy. Use ``page`` inside Layout and
 * ``immersive`` for lobby→game so we never flash the generic card skeleton.
 */
const GeogusserFlowStatus = ({
  message = 'Loading',
  detail = null,
  variant = 'page',
}) => {
  const immersive = variant === 'immersive';
  return (
    <div
      className={`gg-flow-status${immersive ? ' gg-flow-status--immersive' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message}
      data-testid="geogusser-flow-status"
    >
      <div className="gg-flow-status-inner">
        <p className="gg-flow-status-message">{message}</p>
        {detail ? <p className="gg-flow-status-detail">{detail}</p> : null}
        <div className="gg-flow-status-bar" aria-hidden>
          <span />
        </div>
      </div>
    </div>
  );
};

export default GeogusserFlowStatus;
